const records = 'orders';
const items = 'order-items';
const shipments = 'order-shipments';

export default {
  records,
  items,
  shipments,
};
